import { getDefaultClient } from '../../factory';
// @endpoint POST /tenant/accept-invitation
// @controller GlobalAction.AcceptInvitation
export async function acceptTenantInvitation(data) {
    return getDefaultClient().post('/tenant/accept-invitation', data);
}
// @endpoint POST /tenant/accept-invitation-link
// @controller GlobalAction.AcceptInvitationLink
export async function acceptTenantInvitationLink(data) {
    return getDefaultClient().post('/tenant/accept-invitation-link', data);
}
// @endpoint POST /tenant
// @controller GlobalAction.CreateTenant
export async function createTenant(data) {
    return getDefaultClient().post('/tenant', data);
}
// @endpoint POST /tenant/set-default
// @controller GlobalAction.SetDefaultTenant
export async function setDefaultTenant(data) {
    return getDefaultClient().post('/tenant/set-default', data);
}
// @endpoint POST /auth/email-verify
// @controller GlobalAction.EmailVerify
export async function verifyEmail(data) {
    return getDefaultClient().post('/auth/email-verify', data);
}
// @endpoint POST /auth/resend-email-verify
// @controller GlobalAction.EmailVerifyResend
export async function resendEmailVerify(data) {
    return getDefaultClient().post('/auth/resend-email-verify', data);
}
// @endpoint POST /auth/email-verify-status
// @controller GlobalAction.EmailVerifyStatus
export async function getEmailVerifyStatus() {
    return getDefaultClient().post('/auth/email-verify-status');
}
// @endpoint GET /entry
// @controller GlobalAction.Entry
export async function getEntry(refresh = false) {
    // mock cached
    return getDefaultClient().get('/entry');
}
// @endpoint GET /tenant/authrole
// @controller GlobalAction.GetAuthRole
export async function getTenantAuthRole() {
    return getDefaultClient().get('/tenant/authrole');
}
// @endpoint GET /tenant/invitation-link/:id
// @controller GlobalAction.GetInvitationLink
export async function getTenantInvitationLink(id) {
    return getDefaultClient().get(`/tenant/invitation-link/${id}`);
}
// @endpoint GET /link/:name
// @controller GlobalAction.LinkTo
export async function getLink(name) {
    return getDefaultClient().get(`/link/${name}`);
}
// @endpoint POST /user-profile/set-email
// @controller GlobalAction.ProfileSetEmail
export async function setProfileEmail(data) {
    return getDefaultClient().post('/user-profile/set-email', data);
}
// @endpoint DELETE /user-profile/set-email/:hashid
// @controller GlobalAction.ProfileSetEmailCancel
export async function cancelProfileEmail(hashid) {
    return getDefaultClient().delete(`/user-profile/set-email/${hashid}`);
}
// @endpoint GET /user-profile/set-email
// @controller GlobalAction.ProfileSetEmailHistory
export async function getProfileEmailHistory() {
    return getDefaultClient().get('/user-profile/set-email');
}
